import React, { useMemo, useRef } from "react";
import { Badge, Button, Col, Form, InputGroup, Modal, Row, Spinner, Table } from "react-bootstrap";
import Fontstyling, {
} from "../../../components/common/comman";
import { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import CustomButton from "../../../components/common/CustomButton";
import toastFile from "../../../Service/ToastFile";
import Required from "../../../components/Required";
import { useSelector } from "react-redux";
import editIcon from "../../../assets/icon/pencil-fill.svg";
import editIconWhite from "../../../assets/icon/pencil-fill-white.svg";
import moment from "moment";
import CustomReactMaterialTable from "../../../components/common/CustomReactMaterialTable";
import '../RxBlockPricingEx/style.css';
import { IoEyeOutline } from "react-icons/io5";
import { CreateOrUpdateRxBlockPricing, GetAllAccessConditionsbysizeorcost, GetAllBenefitBuyingApproach, GetAllContractPeriod, GetAllGPO, GetAllPBM, GetAllPBMBuyingStructure, GetAllPlanSponsorType, GetAllPresentationAlias, GetAllPricingStructure, GetAllRebatesApproachHIV, GetAllRetailNetwork3090, GetAllRxBlockPricing, GetCurrentPeriodData, GetFormularyType, GetGPOById, GetRebateStructure, GetSpecialtyPharmacyNetwork, ImportRxBlockPricing } from "../../../api/EmpowRxApi/blockPricing";
import { DownloadCensusErrorFile } from "../../../api/User/ACG/ImportCensusApi";
import { toast } from "react-toastify";

const schema = Yup.object().shape({
    PBM: Yup.string().trim().required("This field requried"),
});
const schemaModel = Yup.object().shape({
    Presentation_Alias: Yup.string().trim().required("This field is required"),
    Plan_Sponsor_Type: Yup.string().trim().required("This field is required"),
    Benefit_Buying_Approach: Yup.string().trim().required("This field is required"),
    Pricing_Structure: Yup.string().trim().required("This field is required"),
    Formulary_Type: Yup.string().trim().required("This field is required"),
    Rebates_Approach_HIV: Yup.string().trim().required("This field is required"),
    Retail_Network_30_90: Yup.string().trim().required("This field is required"),
    Specialty_Pharmacy_Network: Yup.string().trim().required("This field is required"),
    PBM_Buying_Structure: Yup.string().trim().required("This field is required"),
    // GPO: Yup.string().trim().required("This field is required"),
    PBM: Yup.string().trim().required("This field is required"),
    Access_Conditions_by_size_or_cost: Yup.string().trim().required("This field is required"),
    Contract_Period: Yup.string().trim().required("This field is required"),
    Rebate_Structure: Yup.string().trim().required("This field is required"),
    Retail_30_Generic: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Retail_30_Brand: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Retail_30_Dispensing_Fee: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Retail_90_Generic: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Retail_90_Brand: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Retail_90_Dispensing_Fee: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Mail_Generic: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Mail_Brand: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Mail_Dispensing_Fee: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Specialty_Generic: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Specialty_Brand: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Specialty_Dispensing_Fee: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    // Current_Period: Yup.string().trim().required("This field is required"),
    // Current_Period_Start_Date: Yup.string().trim().required("This field is required"),
    // Current_Period_End_Date: Yup.string().trim().required("This field is required"),
    LDD_Discount: Yup.number().typeError("Please enter a valid number.").required("This field is required")
    .min(0, "Please enter value between 0 and less than 1.")
    .lessThan(1, "Please enter value between 0 and less than 1."),
    Per_Claim_Transaction_Fee: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Pass_Thru_Admin_Fee: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Retail_30_Rebate: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Retail_90_Rebate: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Mail_Rebate: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    Specialty_Rebate: Yup.number().required("This field is required").typeError("Please enter a valid number."),
    LDD_Rebate: Yup.number().required("This field is required").typeError("Please enter a valid number."),
});


const RxBlockPricingEx = () => {
    const user = useSelector((state) => state.userDetails.value);
    const userRoleString = "client";
    // console.log({user});
    const [data, setData] = useState([])
    const [allData, setAllData] = useState([])
    const [newPricingDetils, setNewPricingDetils] = useState()
    const [showTable, setShowTable] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState();
    const [witchAction, setWitchAction] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [showMoreModal, setShowMoreModal] = useState(false);
    const [isGetData, setIsGetData] = useState(false);
    const [currentPeriod, setCurrentPeriod] = useState({
        quarter: '',
        start: '',
        end: '',
    });
    const [selectedRow, setSelectedRow] = useState(null);
    const [disable,setDisable] = useState(false)
    const [PBMID,setPBMID] = useState(null);
    const [message, setMessage] = useState({
        isModal: false,
        file: "",
        success: undefined,
      });
    const [showEditIcon,setShowEditIcon] = useState(false);
    const [openEditDate,setOpenEditDate] = useState({
        OpenEditStartDate:'',
        OpenEditEndDate:''
    });
    const [dropDownList, setDropDownList] = useState({
        PBMList: [],
        presentationAliasList: [],
        planSponserTypeList: [],
        rebateStructureList: [],
        accessConditionsList: [],
        pricingStructureList: [],
        formularyTypeList: [],
        specPharmNetworkList: [],
        contractPeriodList: [],
        pbmBuyingStructureList: [],
        rebatesApproachHIVList: [],
        benefitBuyingApproachList: [],
        retailNetwork3090List: [],
    });
    const fileInputRef = useRef();
    const formikRef = useRef();
    const request_date = moment().format("YYYY-MM-DD");
    
    const column = useMemo(
        () => [
            {
                header: "Actions",
                size: 100,
                enableColumnFilter: false,
                accessorFn: (rowData) =>
                        <div className="text-center">
                            {showEditIcon ? 
                            <img
                                src={editIcon}
                                width="11"
                                className="m-2 cursor-pointer"
                                onClick={() => {
                                    setWitchAction('update');
                                    setSelectedRowData(rowData);
                                    setShowModal(true);
                                }}
                            /> 
                            : 
                            <IoEyeOutline
                                width="11"
                                className="m-2 cursor-pointer"
                                style={{ fontSize: "15px" }}
                                onClick={() => {
                                    setWitchAction("showMore");
                                    setSelectedRowData(rowData);
                                    setShowMoreModal(true);
                                }}
                            /> 
                            } 
                        </div>
            },
            {
                header: "Current Period",
                accessorKey: "Current_Period",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Presentation Alias",
                accessorKey: "Presentation_Alias_Name", filtering: true,
                enableColumnFilter: false,
                filterVariant: "text",
            },
            // {
            //     header: "Plan Sponsor Type",
            //     accessorKey: "Plan_Sponsor_Type_Name",
            //     enableColumnFilter: false,
            //     filterVariant: "text",
            // },
            {
                header: "Medical/Pharmacy Benefit Buying Approach",
                accessorKey: "Benefit_Buying_Approach_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Pricing Structure",
                accessorKey: "Pricing_Structure_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Formulary Type",
                accessorKey: "Formulary_Type_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Rebates Approach for HIV Brand Claims",
                accessorKey: "Rebates_Approach_HIV_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Retail Network (30/90)",
                accessorKey: "Retail_Network_30_90_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Specialty Pharmacy Network",
                accessorKey: "Specialty_Pharmacy_Network_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            // {
            //     header: "PBM Buying Structure",
            //     accessorKey: "PBM_Buying_Structure_Name",
            //     enableColumnFilter: false,
            //     filterVariant: "text",
            // },
            {
                header: "GPO (Coalition)",
                accessorKey: "GPO_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "PBM",
                accessorKey: "PBM_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Access Conditions by size or cost",
                accessorKey: "Access_Conditions_by_size_or_cost_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Contract Period",
                accessorKey: "Contract_Period_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Rebate Structure",
                accessorKey: "Rebate_Structure_Name",
                enableColumnFilter: false,
                filterVariant: "text",
            },
            {
                header: "Retail 30 Generic",
                accessorKey: "Retail_30_Generic",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                      {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                  ),
            },
            {
                header: "Retail 30 Brand",
                accessorKey: "Retail_30_Brand",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                      {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                  ),
            },
            {
                header: "Retail 30 Dispensing Fee",
                accessorKey: "Retail_30_Dispensing_Fee",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "Retail 90 Generic",
                accessorKey: "Retail_90_Generic",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                      {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                  ),
            },
            {
                header: "Retail 90 Brand",
                accessorKey: "Retail_90_Brand",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                      {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                  ),
            },
            {
                header: "Retail 90 Dispensing Fee",
                accessorKey: "Retail_90_Dispensing_Fee",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "Mail Generic",
                accessorKey: "Mail_Generic",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                      {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                  ),
            },
            {
                header: "Mail Brand",
                accessorKey: "Mail_Brand",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                      {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                  ),
            },
            {
                header: "Mail Dispensing Fee",
                accessorKey: "Mail_Dispensing_Fee",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "Specialty Generic",
                accessorKey: "Specialty_Generic",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                      {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                  ),
            },
            {
                header: "Specialty Brand",
                accessorKey: "Specialty_Brand",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                      {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                  ),
            },
            {
                header: "Specialty Dispensing Fee",
                accessorKey: "Specialty_Dispensing_Fee",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },              
            {
                header: "LDD Discount",
                accessorKey: "LDD_Discount",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                      {cell.getValue() !== undefined ? `${(cell.getValue() * 100).toFixed(2)}%` : ""}
                    </span>
                  ),
            },
            {
                header: "per Claim Transaction Fee",
                accessorKey: "Per_Claim_Transaction_Fee",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "Pass-thru Admin Fee",
                accessorKey: "Pass_thru_Admin_Fee",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
                
            },
            {
                header: "Retail 30 Rebate",
                accessorKey: "Retail_30_Rebate",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "Retail 90 Rebate",
                accessorKey: "Retail_90_Rebate",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "Mail Rebate",
                accessorKey: "Mail_Rebate",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "Specialty Rebate",
                accessorKey: "Specialty_Rebate",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            {
                header: "LDD Rebate",
                accessorKey: "LDD_Rebate",
                enableColumnFilter: false,
                filterVariant: "text",
                Cell: ({ cell }) => (
                    <span>
                        {cell.getValue() !== undefined ? `$${(+cell.getValue()).toFixed(2)}` : ""}
                    </span>
                ),
            },
            
        ],
        [showEditIcon],
    );

    const getCurrentPeriod = () => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1;
        const quarter = Math.ceil(currentMonth / 3);
        const startDate = new Date(currentYear, (quarter - 1) * 3, 1);
        const endDate = new Date(currentYear, quarter * 3, 0);
        const formatDate = (date) => {
            return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        };
        const formattedStartDate = formatDate(startDate);
        const formattedEndDate = formatDate(endDate);

        setCurrentPeriod({
            quarter: `Q${quarter}-${currentYear}`,
            start: formattedStartDate,
            end: formattedEndDate,
        });
    };

    useEffect(() => {
        if (showModal === false) {
            setSelectedRowData(null);
            setWitchAction('')
        }
    }, [showModal]);

    useEffect(() => {
        getCurrentPeriod();
        getGPOById();
        // getCurrentPeriodDate();
        getAllRxBlockPricing(true);
        getAccessConditionsBySizeOrCost();
        getAllBenefitBuyingApproach();
        getAllRebatesApproachHIV();
        getAllRetailNetwork3090();
        getAllPlanSponsorType();
        getAllPresentationAlias(user?.gpoId);
        getAllContractPeriod(user?.gpoId);
        getAllPBMBuyingStructure(user?.gpoId);
        getRebateStructure(user?.gpoId);
        getPBMList(user?.gpoId);
    }, []);
    
    useEffect(() => {
        if (selectedRowData) {
            const alias = selectedRowData ? {
                Id: selectedRowData?.Presentation_Alias_Id,
                Label: selectedRowData?.Presentation_Alias_Name,
                ExtensionType: selectedRowData?.Presentation_Alias_ExtensionType,
            } : null;
    
            setDisable(alias && alias.Label ? true : false);
            getFormularyType(alias?.ExtensionType);
            getPricingStructure(alias?.ExtensionType);
            getSpecPharmNetwork(alias?.ExtensionType);
        }
        
    }, [selectedRowData]);

    // const getCurrentPeriodDate = () => {
    //     GetCurrentPeriodData(request_date)
    //         .then((res) => {
    //             if (res?.status === 200 || res?.status === 204) {
    //                 let data = res.data.data;
    //                 setShowEditIcon(checkDateBetween(data.openEditStartDate, data.openEditEndDate));
    //                 setOpenEditDate({OpenEditStartDate:data.openEditStartDate,OpenEditEndDate:data.openEditEndDate})
    //             }
    //         })
    //         .catch((err) => console.log({ err }));
    // }

    const getGPOById = () => {
        GetGPOById(user?.gpoId)
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
                    let data = res.data.data;
                    setShowEditIcon(checkDateBetween(data.Start_Date, data.End_Date));
                    setOpenEditDate({OpenEditStartDate:data.Start_Date,OpenEditEndDate:data.End_Date})
                }
            })
            .catch((err) => console.log({ err }));
    }

    const checkDateBetween = (start, end) => {
        let today = moment();
        let startDate = moment(start, 'YYYY-MM-DD').startOf('day').format("YYYY-MM-DDTHH:mm:ss");
        let endDate = moment(end, 'YYYY-MM-DD').endOf('day').format("YYYY-MM-DDTHH:mm:ss");
        console.log({ startDate, endDate })
        let isWithinRange = today.isBetween(startDate, endDate, null, '[]');
        return isWithinRange;
    };

    const getAllRxBlockPricing = (updateAll) => {
        setIsLoading(true);
        let payload = {
            gpo: user?.gpoId,
            request_date: request_date
        }
        GetAllRxBlockPricing(payload)
            .then((res) => {
                if (res?.status === 200) {
                    if (updateAll) {
                        setData(res.data.data);
                        setAllData(res.data.data);
                        setIsLoading(false);
                    } else {
                        setAllData(res.data.data);
                    }

                } else {
                    console.log('error while getting block pricing data');
                }
            })
            .finally(() => {
                if (updateAll) {
                    setShowTable(true);
                    setIsLoading(false);
                }
            });
    };

    const getRxBlockPricingFiltered = (pbmId) => {
        setIsLoading(true);
        let payload = {
            gpo: user?.gpoId,
            pbm: pbmId,
            request_date: request_date
        }
        GetAllRxBlockPricing(payload)
            .then((res) => {
                if (res?.status === 200) {
                    setData(res.data.data);
                    setIsLoading(false);
                } else {
                    console.log('error while getting block pricing data');
                }
            })
            .finally(() => {
                setShowTable(true);
                setIsLoading(false);
            });
    };


    const getAccessConditionsBySizeOrCost = () => {
        GetAllAccessConditionsbysizeorcost()
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
                    setDropDownList((prevList) => ({ ...prevList, accessConditionsList: res.data.data }));
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getAllBenefitBuyingApproach = () => {
        GetAllBenefitBuyingApproach()
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
                    setDropDownList((prevList) => ({ ...prevList, benefitBuyingApproachList: res.data.data }));
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getAllRebatesApproachHIV = () => {
        GetAllRebatesApproachHIV()
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
                    setDropDownList((prevList) => ({ ...prevList, rebatesApproachHIVList: res.data.data }));
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getAllRetailNetwork3090 = () => {
        GetAllRetailNetwork3090()
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
                    setDropDownList((prevList) => ({ ...prevList, retailNetwork3090List: res.data.data }));
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getAllPlanSponsorType = () => {
        GetAllPlanSponsorType()
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
                    setDropDownList((prevList) => ({ ...prevList, planSponserTypeList: res.data.data }));
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getPBMList = (gpoId) => {
        GetAllPBM(gpoId)
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
                    setDropDownList((prevList) => ({ ...prevList, PBMList: res.data.data }));
                }
            })
            .catch((err) => console.log({ err }));
    };
    const getAllContractPeriod = (gpoId) => {
        GetAllContractPeriod(gpoId)
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
        setDropDownList((prevList)=>({...prevList, contractPeriodList: res.data.data}));
                }
            })
            .catch((err) => console.log({ err }));
    };
    const getAllPBMBuyingStructure = (gpoId) => {
        GetAllPBMBuyingStructure(gpoId)
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
        setDropDownList((prevList)=>({...prevList, pbmBuyingStructureList: res.data.data}));
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getRebateStructure = (gpoId) => {
        GetRebateStructure(gpoId)
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
        setDropDownList((prevList)=>({...prevList, rebateStructureList: res.data.data}));
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getAllPresentationAlias = (gpoId) => {
        GetAllPresentationAlias(gpoId)
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
                    setDropDownList((prevList) => ({ ...prevList, presentationAliasList: res.data.data }));
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getFormularyType = (extType) => {
        GetFormularyType(extType)
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
        setDropDownList((prevList)=>({...prevList, formularyTypeList: res.data.data}));
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getPricingStructure = (extType) => {
        GetAllPricingStructure(extType)
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
        setDropDownList((prevList)=>({...prevList, pricingStructureList: res.data.data}));
                }
            })
            .catch((err) => console.log({ err }));
    };

    const getSpecPharmNetwork = (extType) => {
        GetSpecialtyPharmacyNetwork(extType)
            .then((res) => {
                if (res?.status === 200 || res?.status === 204) {
        setDropDownList((prevList)=>({...prevList, specPharmNetworkList: res.data.data}));
                }
            })
            .catch((err) => console.log({ err }));
    };
    
    const formatDate = (dateString) => {
        const [month, day, year] = dateString.split('/').map(Number);
        const dateObject = new Date(Date.UTC(year, month - 1, day, 0, 0, 0, 0));
        if (isNaN(dateObject.getTime())) {
            console.error('Invalid date format:', dateString);
            return null;
        }
        const formattedDate = dateObject.toISOString();
        return formattedDate;
    };
    
    
    const handleActions1 = async (values) => {
        // console.log("values", values)
        setShowTable(false);
        let payload = {
            id: selectedRowData?.Id ? selectedRowData?.Id : 0,
            presentation_Alias: JSON.parse(values?.Presentation_Alias).Id,
            plan_Sponsor_Type: +values.Plan_Sponsor_Type,
            benefit_Buying_Approach: +values.Benefit_Buying_Approach,
            pricing_Structure: +values.Pricing_Structure,
            formulary_Type: +values.Formulary_Type,
            rebates_Approach_HIV: +values.Rebates_Approach_HIV,
            retail_Network_30_90: +values.Retail_Network_30_90,
            specialty_Pharmacy_Network: +values.Specialty_Pharmacy_Network,
            pbM_Buying_Structure: +values.PBM_Buying_Structure,
            gpo: user?.gpoId,
            pbm: +values.PBM,
            access_Conditions_by_size_or_cost: +values.Access_Conditions_by_size_or_cost,
            contract_Period: +values.Contract_Period,
            rebate_Structure: +values.Rebate_Structure,
            retail_30_Generic: +values.Retail_30_Generic,
            retail_30_Brand: +values.Retail_30_Brand,
            retail_30_Dispensing_Fee: +values.Retail_30_Dispensing_Fee,
            retail_90_Generic: +values.Retail_90_Generic,
            retail_90_Brand: +values.Retail_90_Brand,
            retail_90_Dispensing_Fee: +values.Retail_90_Dispensing_Fee,
            mail_Generic: +values.Mail_Generic,
            mail_Brand: +values.Mail_Brand,
            mail_Dispensing_Fee: +values.Mail_Dispensing_Fee,
            specialty_Generic: +values.Specialty_Generic,
            specialty_Brand: +values.Specialty_Brand,
            specialty_Dispensing_Fee: +values.Specialty_Dispensing_Fee,
            ldD_Discount: +values.LDD_Discount,
            per_Claim_Transaction_Fee: +values.Per_Claim_Transaction_Fee,
            pass_thru_Admin_Fee: +values.Pass_Thru_Admin_Fee,
            retail_30_Rebate: +values.Retail_30_Rebate,
            retail_90_Rebate: +values.Retail_90_Rebate,
            mail_Rebate: +values.Mail_Rebate,
            specialty_Rebate: +values.Specialty_Rebate,
            ldD_Rebate: +values.LDD_Rebate,
            comments: values.Comments,
            current_Period: currentPeriod?.quarter,
            current_Period_Start_Date: formatDate(currentPeriod?.start),
            current_Period_End_Date: formatDate(currentPeriod?.end),
            open_Edit_Start_Date: openEditDate?.OpenEditStartDate,
            open_Edit_End_Date: openEditDate?.OpenEditEndDate,
            userId: user?.id,
            userRole: userRoleString
        };
        CreateOrUpdateRxBlockPricing(payload).then((res) => {
            if (res?.status === 200) {
                toastFile(witchAction === "add" ? "new" : "update");
                getAllRxBlockPricing();
                getRxBlockPricingFiltered(PBMID);
            } else {
                toast.error(res?.response.data.message)
            }
        }).finally(() => {
            setShowTable(true);
            setShowModal(false);
        });
    };
    const downloadExisRxBlockPricing = (data, filename) => {
           let table_col = [...column,  {
            header: "Comments",
            accessorKey: "Comments",
            enableColumnFilter: false,
            filterVariant: "text",
        }]
        const csv = convertToCSV(data, table_col);
        const csvBlob = new Blob([csv], { type: 'text/csv' });
        const csvFile = new File([csvBlob], filename, { type: 'text/csv' });
        const csvUrl = window.URL.createObjectURL(csvFile);
        const link = document.createElement('a');
        link.href = csvUrl;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const convertToCSV = (objArray, columns) => {
        let csv = '';
        const header = columns
            .filter(column => column.header !== 'Actions' &&  column.header !== 'Current Period')
            .map(column => column.header);
        const accessorKey = columns.slice(2).map(column => column.accessorKey);
        csv += header.join(',') + '\r\n';
        objArray?.forEach(obj => {
            const row = accessorKey.map(field => {
                if (obj[field] !== undefined && typeof obj[field] === 'string' && obj[field].includes(',')) {
                    return `"${obj[field]}"`;
                }
                else if (field === 'Contract_Period_Name' && obj[field] !== undefined) {
                    return obj[field].replace(/\r\n/g, ' ');
                }
                return obj[field] !== undefined ? obj[field] : '';
            });
            csv += row.join(',') + '\r\n';
        });
        return csv;
    }

    const handleActions = async (values) => {
        const pbmId = values.PBM ? JSON.parse(values.PBM)?.Id : '';
        setPBMID(pbmId)
        getRxBlockPricingFiltered(pbmId)        
    };
    
    const handleImportFile = (file) => {
        setMessage(true);
        setIsLoading(true);
        if (file === null) {
          setIsLoading(false);
        }  else {
            ImportRxBlockPricing(
                file,
                user?.id,
                user?.gpoName,
                userRoleString,
                moment().format("YYYY-MM-DD")
            )
            .then((res) => {
              if (res.status === 200) {
                if (res.data.success) {
                  if (res.data.message === "failed") {
                    setMessage((prev) => ({
                      isModal: true,
                      file: res.data.file,
                      success: true,
                    }));
                  } else if (res.data.message === "sucessfull") {
                    toastFile("imported");
                    getAllRxBlockPricing();
                    getRxBlockPricingFiltered(PBMID);
                  }
                } else {
                  switch (res.data.message) {
                    case "failed":
                      setMessage((prev) => ({
                        isModal: true,
                        file: res.data.file,
                        success: false,
                      }));
                      break;
                    case "Invalid Template!":
                      toastFile(
                        "File with invalid template. Please upload correct file."
                      );
                      break;
                    case "Not CSV file":
                      toastFile(
                        "The file is not in csv format. Please import csv file."
                      );
                      break;
                    default:
                      toastFile(res.data.message);
                      break;
                  }
                }
              }
            })
            .catch((err) => {
              toastFile(err?.response?.data);
            })
            .finally(() => {
              setIsLoading(false);
              fileInputRef.current.value = "";
            });
        }
      };

    const ClearCriteria = () => {
        getAllRxBlockPricing(true);
        setPBMID(null)
        formikRef.current.resetForm();
    };

    const handleChangeNumberField = (event, handleChange) => {
        const { name, value } = event.target;
        if (/^\d*\.?\d{0,4}$/.test(value)) {
            handleChange({
                target: {
                    name,
                    value: value.trim(),
                },
            });
        }
    };
    

    const handleChangeAmtNumberField = (event, handleChange) => {
        const { name, value } = event.target;
        if (/^\d*\.?\d{0,2}$/.test(value)) {
            handleChange({
                target: {
                    name,
                    value: value.trim(),
                },
            });
        }
    };
    
    
    return (
        <div>
            <Modal
                show={showMoreModal}
                aria-labelledby="contained-modal-header-vcenter"
                centered={witchAction !== "delete"}
                size="xl" // Removed curly braces as it's a string
            >
                <Modal.Header
                    closeButton
                    onHide={() => {
                        setShowMoreModal(false);
                    }}
                >
                    <Modal.Title
                        id="contained-modal-header-vcenter"
                        style={Fontstyling.modalHeading}
                    >
                        View Rates
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: '80vh', overflowY: 'scroll' }}>
                    <Row className="mb-2 gap-3" style={{alignItems:'end'}}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Presentation Alias
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Presentation_Alias"
                                    value={selectedRowData?.Presentation_Alias_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Plan Sponsor Type
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Plan_Sponsor_Type"
                                    value={selectedRowData?.Plan_Sponsor_Type_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Medical/Pharmacy Benefit Buying Approach
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Benefit_Buying_Approach"
                                    value={selectedRowData?.Benefit_Buying_Approach_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Pricing Structure
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Pricing_Structure"
                                    value={selectedRowData?.Pricing_Structure_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-2 gap-3" style={{alignItems:'end'}}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Formulary Type
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Formulary_Type"
                                    value={selectedRowData?.Formulary_Type_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Rebates Approach for HIV Brand Claims
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Rebates_Approach_HIV"
                                    value={selectedRowData?.Rebates_Approach_HIV_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Retail Network (30/90)
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Retail_Network_30_90"
                                    value={selectedRowData?.Retail_Network_30_90_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Specialty Pharmacy Network
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Specialty_Pharmacy_Network"
                                    value={selectedRowData?.Specialty_Pharmacy_Network_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-2 gap-3" style={{alignItems:'end'}}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    PBM Buying Structure
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="PBM_Buying_Structure"
                                    value={selectedRowData?.PBM_Buying_Structure_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    GPO (Coalition)
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="GPO"
                                    value={selectedRowData?.GPO_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    PBM
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="PBM"
                                    value={selectedRowData?.PBM_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Access Conditions by size or cost
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Access_Conditions_by_size_or_cost"
                                    value={selectedRowData?.Access_Conditions_by_size_or_cost_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="w-50 mb-2 gap-3" style={{alignItems:'end'}}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Contract Period
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Contract_Period"
                                    value={selectedRowData?.Contract_Period_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Rebate Structure
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Rebate_Structure"
                                    value={selectedRowData?.Rebate_Structure_Name}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="d-flex mb-2 gap-3" style={{alignItems:'end'}}>
                        <Col  xs={8}>
                            <Row className=" mb-2 gap-3" style={{alignItems:'end'}}>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Retail 30 Generic 
                                        </Form.Label>

                                        <Form.Control
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            disabled
                                            name="Retail_30_Generic"
                                            value={selectedRowData?.Retail_30_Generic ? `${(selectedRowData.Retail_30_Generic * 100).toFixed(2)}%` : ""}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Retail 30 Brand 
                                        </Form.Label>
                                        <Form.Control
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            disabled
                                            name="Retail_30_Brand"
                                            value={selectedRowData?.Retail_30_Brand ? `${(selectedRowData.Retail_30_Brand * 100).toFixed(2)}%` : ""}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Retail 30 Dispensing Fee
                                        </Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                            <Form.Control
                                                className="py-1 rounded-0"
                                                style={Fontstyling.label}
                                                disabled
                                                name="Retail_30_Dispensing_Fee"
                                                value={(+selectedRowData?.Retail_30_Dispensing_Fee).toFixed(2)}
                                            >
                                            </Form.Control>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className=" mb-2 gap-3" style={{alignItems:'end'}}>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Retail 90 Generic 
                                        </Form.Label>
                                        <Form.Control
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            disabled
                                            name="Retail_90_Generic"
                                            value={selectedRowData?.Retail_90_Generic ? `${(selectedRowData.Retail_90_Generic * 100).toFixed(2)}%` : ""}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Retail 90 Brand
                                        </Form.Label>
                                        <Form.Control
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            disabled
                                            name="Retail_90_Brand"
                                            value={selectedRowData?.Retail_90_Brand ? `${(selectedRowData.Retail_90_Brand * 100).toFixed(2)}%` : ""}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Retail 90 Dispensing Fee
                                        </Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                            <Form.Control
                                                className="py-1 rounded-0"
                                                style={Fontstyling.label}
                                                disabled
                                                name="Retail_90_Dispensing_Fee"
                                                value={(+selectedRowData?.Retail_90_Dispensing_Fee).toFixed(2)}
                                            >
                                            </Form.Control>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className=" mb-2 gap-3" style={{alignItems:'end'}}>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Mail Generic 
                                        </Form.Label>
                                        <Form.Control
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            disabled
                                            name="Mail_Generic"
                                            value={selectedRowData?.Mail_Generic ? `${(selectedRowData.Mail_Generic * 100).toFixed(2)}%` : ""}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Mail Brand 
                                        </Form.Label>
                                        <Form.Control
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            disabled
                                            name="Mail_Brand"
                                            value={selectedRowData?.Mail_Brand ? `${(selectedRowData.Mail_Brand * 100).toFixed(2)}%` : ""}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            Mail Dispensing Fee
                                        </Form.Label>
                                        <InputGroup>
                                            <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                            <Form.Control
                                                className="py-1 rounded-0"
                                                style={Fontstyling.label}
                                                disabled
                                                name="Mail_Dispensing_Fee"
                                                value={(+selectedRowData?.Mail_Dispensing_Fee).toFixed(2)}
                                            >
                                            </Form.Control>
                                        </InputGroup>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                        <Col>
                            <Row className=" mb-2 gap-3" style={{alignItems:'end'}}>
                                <Col>
                                    <Form.Group>
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            GPO Comments
                                        </Form.Label>
                                        <Form.Control
                                            rows={12}
                                            type="text"
                                            className="py-1 rounded-0"
                                            style={{ ...Fontstyling.label, height: '163px' }}
                                            disabled
                                            name="Comments"
                                            value={selectedRowData?.Comments}
                                        >
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className="mb-2 gap-3" style={{alignItems:'end'}}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Specialty Generic
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Specialty_Generic"
                                    value={selectedRowData?.Specialty_Generic ? `${(selectedRowData.Specialty_Generic * 100).toFixed(2)}%` : ""}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Specialty Brand
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="Specialty_Brand"
                                    value={selectedRowData?.Specialty_Brand ? `${(selectedRowData.Specialty_Brand * 100).toFixed(2)}%` : ""}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Specialty Dispensing Fee
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="Specialty_Dispensing_Fee"
                                        value={(+selectedRowData?.Specialty_Dispensing_Fee).toFixed(2)}
                                    >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Current Period
                                    <Required />
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    type="text"
                                    name="Current_Period"
                                    value={currentPeriod?.quarter}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-2 gap-3" style={{alignItems:'end'}}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    LDD Discount 
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    name="LDD_Discount"
                                    value={selectedRowData?.LDD_Discount ? `${(selectedRowData.LDD_Discount * 100).toFixed(2)}%` : ""}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    per Claim Transaction Fee
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="Per_Claim_Transaction_Fee"
                                        value={(+selectedRowData?.Per_Claim_Transaction_Fee).toFixed(2)}
                                    >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Pass-thru Admin Fee
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="Pass-thru_Admin_Fee"
                                        // value={selectedRowData?.['Pass-thru_Admin_Fee']}
                                        value={(+selectedRowData?.Pass_thru_Admin_Fee).toFixed(2)}
                                    >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Current Period Start Date
                                    <Required />
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    type='text'
                                    name="Current_Period_Start_Date"
                                    value={currentPeriod?.start}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="mb-2 gap-3" style={{alignItems:'end'}}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Retail 30 Rebate
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="Retail_30_Rebate"
                                        value={(+selectedRowData?.Retail_30_Rebate).toFixed(2)}
                                    >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Retail 90 Rebate
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="Retail_90_Rebate"
                                        value={(+selectedRowData?.Retail_90_Rebate).toFixed(2)}
                                    >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Mail Rebate
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="Mail_Rebate"
                                        value={(+selectedRowData?.Mail_Rebate).toFixed(2)}
                                    >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Current Period End Date
                                    <Required />
                                </Form.Label>
                                <Form.Control
                                    className="py-1 rounded-0"
                                    style={Fontstyling.label}
                                    disabled
                                    type='text'
                                    name="Current_Period_End_Date"
                                    value={currentPeriod?.end}
                                >
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="w-50 mb-2 gap-3" style={{alignItems:'end'}}>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    Specialty Rebate
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="Specialty_Rebate"
                                        value={(+selectedRowData?.Specialty_Rebate).toFixed(2)}
                                    >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Label
                                    className="text-nowrap "
                                    style={Fontstyling.label}
                                >
                                    LDD Rebate
                                </Form.Label>
                                <InputGroup>
                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                    <Form.Control
                                        className="py-1 rounded-0"
                                        style={Fontstyling.label}
                                        disabled
                                        name="LDD_Rebate"
                                        value={(+selectedRowData?.LDD_Rebate).toFixed(2)}
                                    >
                                    </Form.Control>
                                </InputGroup>
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        style={Fontstyling.cancelbutton}
                        type="reset"
                        onClick={() => {
                            setShowMoreModal(false);
                        }}
                    >
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
            <Modal
                show={showModal}
                aria-labelledby="contained-modal-title-vcenter"
                centered={witchAction !== "delete"}
                size="xl"
            >
                <Modal.Header
                    closeButton
                    onHide={() => {
                        setShowModal(false);
                        setSelectedRowData([])
                        setDisable(false)
                    }}
                >
                    <Modal.Title
                        id="contained-modal-title-vcenter"
                        style={Fontstyling.modalHeading}
                    >
                        {witchAction === 'update' ? "Update Rates" : "Add Rates"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: '80vh', overflowY: 'scroll' }}>
                    <Formik
                        enableReinitialize
                        validationSchema={schemaModel}
                        onSubmit={(values) => {
                            try {
                                handleActions1(values);
                            } catch (error) {
                                console.error("Error in onSubmit:", error);
                            }
                        }}
                        initialValues={{
                            Presentation_Alias: selectedRowData ?JSON.stringify({
                                Id: selectedRowData?.Presentation_Alias_Id,
                                Label: selectedRowData?.Presentation_Alias_Name,
                                ExtensionType:selectedRowData?.Presentation_Alias_ExtensionType,
                            }) : '',
                            Plan_Sponsor_Type: selectedRowData ? selectedRowData?.Plan_Sponsor_Type_Id : '',
                            Benefit_Buying_Approach: selectedRowData ? selectedRowData?.Benefit_Buying_Approach_Id : '',
                            Pricing_Structure: selectedRowData ? selectedRowData?.Pricing_Structure_Id : '',
                            Formulary_Type: selectedRowData ? selectedRowData?.Formulary_Type_Id : '',
                            Rebates_Approach_HIV: selectedRowData ? selectedRowData?.Rebates_Approach_HIV_Id : '',
                            Retail_Network_30_90: selectedRowData ? selectedRowData?.Retail_Network_30_90_Id : '',
                            Specialty_Pharmacy_Network: selectedRowData ? selectedRowData?.Specialty_Pharmacy_Network_Id : '',
                            PBM_Buying_Structure: selectedRowData ? selectedRowData?.PBM_Buying_Structure_Id : '',
                            GPO: user?.gpoName,
                            PBM: selectedRowData ? selectedRowData?.PBM_Id : '',
                            Access_Conditions_by_size_or_cost: selectedRowData ? selectedRowData?.Access_Conditions_by_size_or_cost_Id : '',
                            Contract_Period: selectedRowData ? selectedRowData?.Contract_Period_Id : '',
                            Rebate_Structure: selectedRowData ? selectedRowData?.Rebate_Structure_Id : '',
                            Retail_30_Generic: selectedRowData ? (+selectedRowData?.Retail_30_Generic).toFixed(4) : '',
                            Retail_30_Brand: selectedRowData ? (+selectedRowData?.Retail_30_Brand).toFixed(4) : '',
                            Retail_30_Dispensing_Fee: selectedRowData ? (+selectedRowData?.Retail_30_Dispensing_Fee).toFixed(2) : '',
                            Retail_90_Generic: selectedRowData ? (+selectedRowData?.Retail_90_Generic).toFixed(4) : '',
                            Retail_90_Brand: selectedRowData ? (+selectedRowData?.Retail_90_Brand).toFixed(4) : '',
                            Retail_90_Dispensing_Fee: selectedRowData ? (+selectedRowData?.Retail_90_Dispensing_Fee).toFixed(2) : '',
                            Mail_Generic: selectedRowData ? (+selectedRowData?.Mail_Generic).toFixed(4) : '',
                            Mail_Brand: selectedRowData ? (+selectedRowData?.Mail_Brand).toFixed(4) : '',
                            Mail_Dispensing_Fee: selectedRowData ? (+selectedRowData?.Mail_Dispensing_Fee).toFixed(2) : '',
                            Comments: selectedRowData ? selectedRowData?.Comments : '',
                            Specialty_Generic: selectedRowData ? (+selectedRowData?.Specialty_Generic).toFixed(4) : '',
                            Specialty_Brand: selectedRowData ? (+selectedRowData?.Specialty_Brand).toFixed(4) : '',
                            Specialty_Dispensing_Fee: selectedRowData ? (+selectedRowData?.Specialty_Dispensing_Fee).toFixed(2) : '',
                            Current_Period: currentPeriod?.quarter,
                            LDD_Discount: selectedRowData ? (+selectedRowData?.LDD_Discount).toFixed(4) : '',
                            Per_Claim_Transaction_Fee: selectedRowData ? (+selectedRowData?.Per_Claim_Transaction_Fee).toFixed(2) : '',
                            Pass_Thru_Admin_Fee: selectedRowData ? (+selectedRowData?.Pass_thru_Admin_Fee).toFixed(2) : '',
                            Current_Period_Start_Date: currentPeriod?.start,
                            Retail_30_Rebate: selectedRowData ? (+selectedRowData?.Retail_30_Rebate).toFixed(2) : '',
                            Retail_90_Rebate: selectedRowData ? (+selectedRowData?.Retail_90_Rebate).toFixed(2) : '',
                            Mail_Rebate: selectedRowData ?(+selectedRowData?.Mail_Rebate).toFixed(2) : '',
                            Current_Period_End_Date: currentPeriod?.end,
                            Specialty_Rebate: selectedRowData ? (+selectedRowData?.Specialty_Rebate).toFixed(2) : '',
                            LDD_Rebate: selectedRowData ? (+selectedRowData?.LDD_Rebate).toFixed(2) : '',

                        }}
                    >
                        {({
                            handleSubmit,
                            handleChange,
                            handleBlur,
                            setFieldValue,
                            values,
                            touched,
                            isValid,
                            errors,
                            resetForm
                        }) => {
                            const handleFormSubmit = async (e) => {
                                e.preventDefault();
                                 handleSubmit(e);
                                if (Object.keys(errors).length > 0) {
                                    const firstErrorField = Object.keys(errors)[0];
                                    const errorFieldElement = document.getElementsByName(firstErrorField)[0];
                                    if (errorFieldElement) {
                                        errorFieldElement.focus();
                                    }
                                }
                            };
                            return (
                                <Form onSubmit={(e) => {
                                    handleFormSubmit(e);
                                }} id="submitblockPricingExtrnal" >
                                    <Row className="mb-3 gap-3" >
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Presentation Alias
                                                      <Required />
                                                </Form.Label>
                                                <Form.Select
                                                    className="py-1 rounded-0"
                                                    type='text'
                                                    style={Fontstyling.label}
                                                    name="Presentation_Alias"
                                                    disabled={witchAction == 'update'}
                                                    onChange={(e) => {
                                                        let { value } = e.target;
                                                        handleChange(e);
                                                        // console.log('value',value)
                                                        setDisable(value.length !== 0);
                                                        let val = JSON.parse(value);
                                                        getFormularyType(val?.ExtensionType);
                                                        getPricingStructure(val?.ExtensionType);
                                                        getSpecPharmNetwork(val?.ExtensionType);
                                                    }}
                                                    
                                                    onBlur={handleBlur}
                                                    isInvalid={
                                                        errors.Presentation_Alias &&
                                                        touched.Presentation_Alias
                                                    }
                                                    value={values.Presentation_Alias}
                                                >
                                                    <option value={""}>Select Presentation Alias</option>
                                                    {dropDownList.presentationAliasList?.map((el, elInd) => (
                                                        <option key={elInd}
                                                            value={JSON.stringify(el)}
                                                            // value={el.Value}
                                                        >
                                                            {el.Label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {errors.Presentation_Alias && touched.Presentation_Alias && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Presentation_Alias}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Plan Sponsor Type
                                                      <Required />
                                                </Form.Label>
                                                <Form.Select
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    name="Plan_Sponsor_Type"
                                                    type='text'
                                                    onChange={handleChange}
                                                    disabled={witchAction == 'update'}
                                                    onBlur={handleBlur}
                                                    isInvalid={
                                                        errors.Plan_Sponsor_Type &&
                                                        touched.Plan_Sponsor_Type
                                                    }
                                                    value={values.Plan_Sponsor_Type}
                                                >
                                                    <option value={""}>Select Plan Sponsor Type</option>
                                                    {dropDownList.planSponserTypeList?.map((el, elInd) => (
                                                        <option key={elInd}
                                                            // value={JSON.stringify(el)}
                                                            value={el.Id}
                                                        >
                                                            {el.Label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {errors.Plan_Sponsor_Type && touched.Plan_Sponsor_Type && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Plan_Sponsor_Type}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Medical/Pharmacy Benefit Buying Approach
                                                      <Required />
                                                </Form.Label>
                                                <Form.Select
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    name="Benefit_Buying_Approach"
                                                    type='text'
                                                    onChange={handleChange}
                                                    disabled={witchAction == 'update'}
                                                    onBlur={handleBlur}
                                                    isInvalid={
                                                        errors.Benefit_Buying_Approach === "" &&
                                                        touched.Benefit_Buying_Approach
                                                    }
                                                    value={values.Benefit_Buying_Approach}
                                                >
                                                    <option value={""}>Select Medical/Pharmacy..</option>
                                                    {dropDownList.benefitBuyingApproachList?.map((el, elInd) => (
                                                        <option key={elInd}
                                                            // value={JSON.stringify(el)}
                                                            value={el.Id}
                                                        >
                                                            {el.Label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {errors.Benefit_Buying_Approach && touched.Benefit_Buying_Approach && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Benefit_Buying_Approach}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Pricing Structure
                                                      <Required />
                                                </Form.Label>
                                                <Form.Select
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    name="Pricing_Structure"
                                                    type='text'
                                                    disabled={!disable || witchAction == 'update'}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    isInvalid={
                                                        errors.Pricing_Structure &&
                                                        touched.Pricing_Structure
                                                    }
                                                    value={values.Pricing_Structure}
                                                >
                                                    <option value={""}>Select Pricing Structure</option>
                                                    {dropDownList.pricingStructureList?.map((el, elInd) => (
                                                        <option key={elInd}
                                                            // value={JSON.stringify(el)}
                                                            value={el.Id}
                                                        >
                                                            {el.Label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {errors.Pricing_Structure && touched.Pricing_Structure && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Pricing_Structure}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3 gap-3" >
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Formulary Type
                                                      <Required />
                                                </Form.Label>
                                                <Form.Select
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    name="Formulary_Type"
                                                    type='text'
                                                    disabled={!disable || witchAction == 'update'}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    isInvalid={
                                                        errors.Formulary_Type &&
                                                        touched.Formulary_Type
                                                    }
                                                    value={values.Formulary_Type}
                                                >
                                                    <option value={""}>Select Formulary Type</option>
                                                    {dropDownList.formularyTypeList?.map((el, elInd) => (
                                                        <option key={elInd}
                                                            // value={JSON.stringify(el)}
                                                            value={el.Id}
                                                            defaultValue={el.Id}
                                                        >
                                                            {el.Label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {errors.Formulary_Type && touched.Formulary_Type && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Formulary_Type}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Rebates Approach for HIV Brand Claims
                                                      <Required />
                                                </Form.Label>
                                                <Form.Select
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    name="Rebates_Approach_HIV"
                                                    type='text'
                                                    onChange={handleChange}
                                                    disabled={witchAction == 'update'}
                                                    onBlur={handleBlur}
                                                    isInvalid={
                                                        errors.Rebates_Approach_HIV &&
                                                        touched.Rebates_Approach_HIV
                                                    }
                                                    value={values.Rebates_Approach_HIV}
                                                >
                                                    <option value={""}>Select Rebates Approach HIV</option>
                                                    {dropDownList.rebatesApproachHIVList?.map((el, elInd) => (
                                                        <option key={elInd}
                                                            // value={JSON.stringify(el)}
                                                            value={el.Id}
                                                        >
                                                            {el.Label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {errors.Rebates_Approach_HIV && touched.Rebates_Approach_HIV && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Rebates_Approach_HIV}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Retail Network (30/90)
                                                      <Required />
                                                </Form.Label>
                                                <Form.Select
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    name="Retail_Network_30_90"
                                                    type='text'
                                                    onChange={handleChange}
                                                    disabled={witchAction == 'update'}
                                                    onBlur={handleBlur}
                                                    isInvalid={
                                                        errors.Retail_Network_30_90 &&
                                                        touched.Retail_Network_30_90
                                                    }
                                                    value={values.Retail_Network_30_90}
                                                >
                                                    <option value={""}>Select Retail Network (30/90)</option>
                                                    {dropDownList.retailNetwork3090List?.map((el, elInd) => (
                                                        <option key={elInd}
                                                            // value={JSON.stringify(el)}
                                                            value={el.Id}
                                                        >
                                                            {el.Label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {errors.Retail_Network_30_90 && touched.Retail_Network_30_90 && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Retail_Network_30_90}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Specialty Pharmacy Network
                                                      <Required />
                                                </Form.Label>
                                                <Form.Select
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    name="Specialty_Pharmacy_Network"
                                                    type='text'
                                                    disabled={!disable || witchAction == 'update'}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    isInvalid={
                                                        errors.Specialty_Pharmacy_Network &&
                                                        touched.Specialty_Pharmacy_Network
                                                    }
                                                    value={values.Specialty_Pharmacy_Network}
                                                >
                                                    <option value={""}>Select Specialty Pharmacy Network</option>
                                                    {dropDownList.specPharmNetworkList?.map((el, elInd) => (
                                                        <option key={elInd}
                                                            // value={JSON.stringify(el)}
                                                            value={el.Id}
                                                        >
                                                            {el.Label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {errors.Specialty_Pharmacy_Network && touched.Specialty_Pharmacy_Network && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Specialty_Pharmacy_Network}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3 gap-3" >
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    PBM Buying Structure
                                                      <Required />
                                                </Form.Label>
                                                <Form.Select
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    name="PBM_Buying_Structure"
                                                    disabled={witchAction == 'update'}
                                                    type='text'
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        let { value } = e.target;
                                                        console.log({ value })
                                                        // getAllPBMBuyingStructure(value);
                                                    }}
                                                    onBlur={handleBlur}
                                                    isInvalid={
                                                        errors.PBM_Buying_Structure &&
                                                        touched.PBM_Buying_Structure
                                                    }
                                                    value={values.PBM_Buying_Structure}
                                                >
                                                    <option value={""}>Select PBM Buying Structure</option>
                                                    {dropDownList.pbmBuyingStructureList?.map((el, elInd) => (
                                                        <option key={elInd}
                                                            // value={JSON.stringify(el)}
                                                            value={el.Id}
                                                        >
                                                            {el.Label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {errors.PBM_Buying_Structure && touched.PBM_Buying_Structure && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.PBM_Buying_Structure}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    GPO (Coalition)
                                                    <Required/>
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    disabled
                                                    name="GPO"
                                                    value={values.GPO}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    PBM
                                                      <Required />
                                                </Form.Label>
                                                <Form.Select
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    name="PBM"
                                                    type='text'
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled={witchAction == 'update'}
                                                    isInvalid={
                                                        errors.PBM &&
                                                        touched.PBM
                                                    }
                                                    value={values.PBM}
                                                >
                                                    <option value={""}>Select PBM</option>
                                                    {dropDownList.PBMList?.map((el, elInd) => (
                                                        <option key={elInd}
                                                            // value={JSON.stringify(el)}
                                                            value={el.Id}
                                                        >
                                                            {el.Label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {errors.PBM && touched.PBM && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.PBM}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Access Conditions by size or cost
                                                      <Required />
                                                </Form.Label>
                                                <Form.Select
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    name="Access_Conditions_by_size_or_cost"
                                                    type='text'
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled={witchAction == 'update'}
                                                    isInvalid={
                                                        errors.Access_Conditions_by_size_or_cost &&
                                                        touched.Access_Conditions_by_size_or_cost
                                                    }
                                                    value={values.Access_Conditions_by_size_or_cost}
                                                >
                                                    <option value={""}>Select Access Conditions..</option>
                                                    {dropDownList.accessConditionsList?.map((el, elInd) => (
                                                        <option key={elInd}
                                                            // value={JSON.stringify(el)}
                                                            value={el.Id}
                                                        >
                                                            {el.Label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {errors.Access_Conditions_by_size_or_cost && touched.Access_Conditions_by_size_or_cost && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Access_Conditions_by_size_or_cost}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="w-50 mb-3 gap-3" >
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Contract Period
                                                      <Required />
                                                </Form.Label>
                                                <Form.Select
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    name="Contract_Period"
                                                    type='text'
                                                    disabled={witchAction == 'update'}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        let { value } = e.target;
                                                        console.log({ value })
                                                        // getAllContractPeriod(value);
                                                    }}
                                                    onBlur={handleBlur}
                                                    isInvalid={
                                                        errors.Contract_Period &&
                                                        touched.Contract_Period
                                                    }
                                                    value={values.Contract_Period}
                                                >
                                                    <option value={""}>Select Contract Period</option>
                                                    {dropDownList.contractPeriodList?.map((el, elInd) => (
                                                        <option key={elInd}
                                                            // value={JSON.stringify(el)}
                                                            value={el.Id}
                                                            
                                                        >
                                                            {el.Label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {errors.Contract_Period && touched.Contract_Period && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Contract_Period}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Rebate Structure
                                                      <Required />
                                                </Form.Label>
                                                <Form.Select
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    name="Rebate_Structure"
                                                    type='text'
                                                    disabled={witchAction == 'update'}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        let { value } = e.target;
                                                        console.log({ value })
                                                        // getRebateStructure(value);
                                                    }}
                                                    onBlur={handleBlur}
                                                    isInvalid={
                                                        values.Rebate_Structure === "" &&
                                                        errors.Rebate_Structure &&
                                                        touched.Rebate_Structure
                                                    }
                                                    value={values.Rebate_Structure}
                                                >
                                                    <option value={""}>Select Rebate Structure</option>
                                                    {dropDownList.rebateStructureList?.map((el, elInd) => (
                                                        <option key={elInd}
                                                            // value={JSON.stringify(el)}
                                                            value={el.Id}
                                                        >
                                                            {el.Label}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {errors.Rebate_Structure && touched.Rebate_Structure && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Rebate_Structure}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="d-flex mb-2 gap-3" >
                                        <Col 
                                        xs={8}
                                        >
                                            <Row className=" mb-3 gap-3" style={{alignItems:'end'}}>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-wrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Retail 30 Generic (e.g, enter 0.2575 for 25.75%)
                                                              <Required />
                                                        </Form.Label>
                                                        <Form.Control
                                                            className="py-1 rounded-0"
                                                            style={Fontstyling.label}
                                                            name="Retail_30_Generic"
                                                            type='text'
                                                            onChange={(event) =>
                                                                handleChangeNumberField(event, handleChange)
                                                            }
                                                            onBlur={handleBlur}
                                                            isInvalid={
                                                                values.Retail_30_Generic === "" &&
                                                                errors.Retail_30_Generic &&
                                                                touched.Retail_30_Generic
                                                            }
                                                            value={values?.Retail_30_Generic}
                                                        >
                                                        </Form.Control>
                                                        {errors.Retail_30_Generic && touched.Retail_30_Generic && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Retail_30_Generic}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-wrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Retail 30 Brand (e.g, enter 0.2575 for 25.75%)
                                                              <Required />
                                                        </Form.Label>
                                                        <Form.Control
                                                            className="py-1 rounded-0"
                                                            style={Fontstyling.label}
                                                            onChange={(event) =>
                                                                handleChangeNumberField(event, handleChange)
                                                            }
                                                            onBlur={handleBlur}
                                                            type='text'
                                                            isInvalid={
                                                                values.Retail_30_Brand === "" &&
                                                                errors.Retail_30_Brand &&
                                                                touched.Retail_30_Brand
                                                            }
                                                            name="Retail_30_Brand"
                                                            value={values?.Retail_30_Brand}
                                                        >
                                                        </Form.Control>
                                                        {errors.Retail_30_Brand && touched.Retail_30_Brand && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Retail_30_Brand}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-wrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Retail 30 Dispensing Fee
                                                              <Required />
                                                        </Form.Label>
                                                        <InputGroup>
                                                            <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                            <Form.Control
                                                                className="py-1 rounded-0"
                                                                style={Fontstyling.label}
                                                                onChange={(event) =>
                                                                    handleChangeAmtNumberField(event, handleChange)
                                                                }
                                                                onBlur={handleBlur}
                                                                maxLength={20}
                                                                type='text'
                                                                isInvalid={
                                                                    values.Retail_30_Dispensing_Fee === "" &&
                                                                    errors.Retail_30_Dispensing_Fee &&
                                                                    touched.Retail_30_Dispensing_Fee
                                                                }
                                                                name="Retail_30_Dispensing_Fee"
                                                                value={values?.Retail_30_Dispensing_Fee}
                                                            >
                                                            </Form.Control>
                                                        </InputGroup>
                                                        {errors.Retail_30_Dispensing_Fee && touched.Retail_30_Dispensing_Fee && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Retail_30_Dispensing_Fee}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row className=" mb-3 gap-3" style={{alignItems:'end'}}>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-wrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Retail 90 Generic (e.g, enter 0.2575 for 25.75%)
                                                              <Required />
                                                        </Form.Label>
                                                        <Form.Control
                                                            className="py-1 rounded-0"
                                                            style={Fontstyling.label}
                                                            onChange={(event) =>
                                                                handleChangeNumberField(event, handleChange)
                                                            }
                                                            onBlur={handleBlur}
                                                            type='text'
                                                            isInvalid={
                                                                values.Retail_90_Generic === "" &&
                                                                errors.Retail_90_Generic &&
                                                                touched.Retail_90_Generic
                                                            }
                                                            name="Retail_90_Generic"
                                                            value={values?.Retail_90_Generic}
                                                        >
                                                        </Form.Control>
                                                        {errors.Retail_90_Generic && touched.Retail_90_Generic && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Retail_90_Generic}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-wrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Retail 90 Brand (e.g, enter 0.2575 for 25.75%)
                                                              <Required />
                                                        </Form.Label>
                                                        <Form.Control
                                                            className="py-1 rounded-0"
                                                            style={Fontstyling.label}
                                                            onChange={(event) =>
                                                                handleChangeNumberField(event, handleChange)
                                                            }
                                                            onBlur={handleBlur}
                                                            type='text'
                                                            isInvalid={
                                                                values.Retail_90_Brand === "" &&
                                                                errors.Retail_90_Brand &&
                                                                touched.Retail_90_Brand
                                                            }
                                                            name="Retail_90_Brand"
                                                            value={values?.Retail_90_Brand}
                                                        >
                                                        </Form.Control>
                                                        {errors.Retail_90_Brand && touched.Retail_90_Brand && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Retail_90_Brand}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-nowrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Retail 90 Dispensing Fee
                                                              <Required />
                                                        </Form.Label>
                                                        <InputGroup>
                                                            <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                            <Form.Control
                                                                className="py-1 rounded-0"
                                                                style={Fontstyling.label}
                                                                onChange={(event) =>
                                                                    handleChangeAmtNumberField(event, handleChange)
                                                                }
                                                                onBlur={handleBlur}
                                                                maxLength={20}
                                                                type='text'
                                                                isInvalid={
                                                                    values.Retail_90_Dispensing_Fee === "" &&
                                                                    errors.Retail_90_Dispensing_Fee &&
                                                                    touched.Retail_90_Dispensing_Fee
                                                                }
                                                                name="Retail_90_Dispensing_Fee"
                                                                value={values?.Retail_90_Dispensing_Fee}
                                                            >
                                                            </Form.Control>
                                                        </InputGroup>
                                                        {errors.Retail_90_Dispensing_Fee && touched.Retail_90_Dispensing_Fee && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Retail_90_Dispensing_Fee}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                            <Row className=" mb-3 gap-3" style={{alignItems:'end'}}>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-wrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Mail Generic (e.g, enter 0.2575 for 25.75%)
                                                              <Required />
                                                        </Form.Label>
                                                        <Form.Control
                                                            className="py-1 rounded-0"
                                                            style={Fontstyling.label}
                                                            onChange={(event) =>
                                                                handleChangeNumberField(event, handleChange)
                                                            }
                                                            onBlur={handleBlur}
                                                            type='text'
                                                            isInvalid={
                                                                values.Mail_Generic === "" &&
                                                                errors.Mail_Generic &&
                                                                touched.Mail_Generic
                                                            }
                                                            name="Mail_Generic"
                                                            value={values?.Mail_Generic}
                                                        >
                                                        </Form.Control>
                                                        {errors.Mail_Generic && touched.Mail_Generic && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Mail_Generic}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-wrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Mail Brand (e.g, enter 0.2575 for 25.75%)
                                                              <Required />
                                                        </Form.Label>
                                                        <Form.Control
                                                            className="py-1 rounded-0"
                                                            style={Fontstyling.label}
                                                            onChange={(event) =>
                                                                handleChangeNumberField(event, handleChange)
                                                            }
                                                            onBlur={handleBlur}
                                                            type='text'
                                                            isInvalid={
                                                                values.Mail_Brand === "" &&
                                                                errors.Mail_Brand &&
                                                                touched.Mail_Brand
                                                            }
                                                            name="Mail_Brand"
                                                            value={values?.Mail_Brand}
                                                        >
                                                        </Form.Control>
                                                        {errors.Mail_Brand && touched.Mail_Brand && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Mail_Brand}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                                <Col>
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-nowrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            Mail Dispensing Fee
                                                              <Required />
                                                        </Form.Label>
                                                        <InputGroup>
                                                            <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                            <Form.Control
                                                                className="py-1 rounded-0"
                                                                style={Fontstyling.label}
                                                                onChange={(event) =>
                                                                    handleChangeAmtNumberField(event, handleChange)
                                                                }
                                                                onBlur={handleBlur}
                                                                maxLength={20}
                                                                type='text'
                                                                isInvalid={
                                                                    values.Mail_Dispensing_Fee === "" &&
                                                                    errors.Mail_Dispensing_Fee &&
                                                                    touched.Mail_Dispensing_Fee
                                                                }
                                                                name="Mail_Dispensing_Fee"
                                                                value={values?.Mail_Dispensing_Fee}
                                                            >
                                                            </Form.Control>
                                                        </InputGroup>
                                                        {errors.Mail_Dispensing_Fee && touched.Mail_Dispensing_Fee && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Mail_Dispensing_Fee}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col>
                                            <Row className=" mb-3 gap-3">
                                                <Col >
                                                    <Form.Group>
                                                        <Form.Label
                                                            className="text-nowrap "
                                                            style={Fontstyling.label}
                                                        >
                                                            GPO Comments
                                                        </Form.Label>
                                                        <Form.Control
                                                            className="py-1 rounded-0"
                                                            as="textarea"
                                                            rows={12}
                                                            style={{ ...Fontstyling.label, height: "100%" }}
                                                            name="Comments"
                                                            type='text'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            isInvalid={
                                                                values.Comments === "" &&
                                                                errors.Comments &&
                                                                touched.Comments
                                                            }
                                                            value={values?.Comments}
                                                        >
                                                        </Form.Control>
                                                        {errors.Comments && touched.Comments && (
                                                            <Form.Label style={Fontstyling.errorlabel}>
                                                                {errors.Comments}
                                                            </Form.Label>
                                                        )}
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3 gap-3" style={{alignItems:'end'}}>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-wrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Specialty Generic (e.g, enter 0.2575 for 25.75%)
                                                      <Required />
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    onChange={(event) =>
                                                        handleChangeNumberField(event, handleChange)
                                                    }
                                                    onBlur={handleBlur}
                                                    type='text'
                                                    isInvalid={
                                                        values.Specialty_Generic === "" &&
                                                        errors.Specialty_Generic &&
                                                        touched.Specialty_Generic
                                                    }
                                                    name="Specialty_Generic"
                                                    value={values?.Specialty_Generic}
                                                >
                                                </Form.Control>
                                                {errors.Specialty_Generic && touched.Specialty_Generic && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Specialty_Generic}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-wrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Specialty Brand (e.g, enter 0.2575 for 25.75%)
                                                      <Required />
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    onChange={(event) =>
                                                        handleChangeNumberField(event, handleChange)
                                                    }
                                                    onBlur={handleBlur}
                                                    type='text'
                                                    isInvalid={
                                                        values.Specialty_Brand === "" &&
                                                        errors.Specialty_Brand &&
                                                        touched.Specialty_Brand
                                                    }
                                                    name="Specialty_Brand"
                                                    value={values?.Specialty_Brand}
                                                >
                                                </Form.Control>
                                                {errors.Specialty_Brand && touched.Specialty_Brand && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Specialty_Brand}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Specialty Dispensing Fee
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        type='text'
                                                        isInvalid={
                                                            values.Specialty_Dispensing_Fee === "" &&
                                                            errors.Specialty_Dispensing_Fee &&
                                                            touched.Specialty_Dispensing_Fee
                                                        }
                                                        name="Specialty_Dispensing_Fee"
                                                        value={values?.Specialty_Dispensing_Fee}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.Specialty_Dispensing_Fee && touched.Specialty_Dispensing_Fee && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Specialty_Dispensing_Fee}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Current Period
                                                      <Required />
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled
                                                    type="text"
                                                    name="Current_Period"
                                                    value={values.Current_Period}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3 gap-3" style={{alignItems:'end'}}>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-wrap "
                                                    style={Fontstyling.label}
                                                >
                                                    LDD Discount (e.g, enter 0.2575 for 25.75%)
                                                      <Required />
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    onChange={(event) =>
                                                        handleChangeNumberField(event, handleChange)
                                                    }
                                                    onBlur={handleBlur}
                                                    type='text'
                                                    isInvalid={
                                                        values.LDD_Discount === "" &&
                                                        errors.LDD_Discount &&
                                                        touched.LDD_Discount
                                                    }
                                                    name="LDD_Discount"
                                                    value={values?.LDD_Discount}
                                                >
                                                </Form.Control>
                                                {errors.LDD_Discount && touched.LDD_Discount && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.LDD_Discount}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    per Claim Transaction Fee
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        type='text'
                                                        isInvalid={
                                                            values.Per_Claim_Transaction_Fee === "" &&
                                                            errors.Per_Claim_Transaction_Fee &&
                                                            touched.Per_Claim_Transaction_Fee
                                                        }
                                                        name="Per_Claim_Transaction_Fee"
                                                        value={values?.Per_Claim_Transaction_Fee}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.Per_Claim_Transaction_Fee && touched.Per_Claim_Transaction_Fee && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Per_Claim_Transaction_Fee}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Pass-thru Admin Fee
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        type='text'
                                                        isInvalid={
                                                            values.Pass_Thru_Admin_Fee === "" &&
                                                            errors.Pass_Thru_Admin_Fee &&
                                                            touched.Pass_Thru_Admin_Fee
                                                        }
                                                        name="Pass_Thru_Admin_Fee"
                                                        value={values?.Pass_Thru_Admin_Fee}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.Pass_Thru_Admin_Fee && touched.Pass_Thru_Admin_Fee && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Pass_Thru_Admin_Fee}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Current Period Start Date
                                                    <Required/>
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled
                                                    type='text'
                                                    name="Current_Period_Start_Date"
                                                    value={values.Current_Period_Start_Date}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="mb-3 gap-3" >
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Retail 30 Rebate
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        type='text'
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        isInvalid={
                                                            values.Retail_30_Rebate === "" &&
                                                            errors.Retail_30_Rebate &&
                                                            touched.Retail_30_Rebate
                                                        }
                                                        name="Retail_30_Rebate"
                                                        value={values?.Retail_30_Rebate}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.Retail_30_Rebate && touched.Retail_30_Rebate && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Retail_30_Rebate}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Retail 90 Rebate
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        type='text'
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        isInvalid={
                                                            values.Retail_90_Rebate === "" &&
                                                            errors.Retail_90_Rebate &&
                                                            touched.Retail_90_Rebate
                                                        }
                                                        name="Retail_90_Rebate"
                                                        value={values?.Retail_90_Rebate}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.Retail_90_Rebate && touched.Retail_90_Rebate && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Retail_90_Rebate}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Mail Rebate
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        type='text'
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        isInvalid={
                                                            values.Mail_Rebate === "" &&
                                                            errors.Mail_Rebate &&
                                                            touched.Mail_Rebate
                                                        }
                                                        name="Mail_Rebate"
                                                        value={values?.Mail_Rebate}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.Mail_Rebate && touched.Mail_Rebate && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Mail_Rebate}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Current Period End Date
                                                    <Required/>
                                                </Form.Label>
                                                <Form.Control
                                                    className="py-1 rounded-0"
                                                    style={Fontstyling.label}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    disabled
                                                    type='text'
                                                    name="Current_Period_End_Date"
                                                    value={values.Current_Period_End_Date}
                                                >
                                                </Form.Control>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row className="w-50 mb-3 gap-3" >
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    Specialty Rebate
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        type='text'
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        isInvalid={
                                                            values.Specialty_Rebate === "" &&
                                                            errors.Specialty_Rebate &&
                                                            touched.Specialty_Rebate
                                                        }
                                                        name="Specialty_Rebate"
                                                        value={values?.Specialty_Rebate}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.Specialty_Rebate && touched.Specialty_Rebate && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.Specialty_Rebate}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group>
                                                <Form.Label
                                                    className="text-nowrap "
                                                    style={Fontstyling.label}
                                                >
                                                    LDD Rebate
                                                      <Required />
                                                </Form.Label>
                                                <InputGroup>
                                                    <InputGroup.Text className="py-0 fw-bold">$</InputGroup.Text>
                                                    <Form.Control
                                                        className="py-1 rounded-0"
                                                        type='text'
                                                        style={Fontstyling.label}
                                                        onChange={(event) =>
                                                            handleChangeAmtNumberField(event, handleChange)
                                                        }
                                                        onBlur={handleBlur}
                                                        maxLength={20}
                                                        isInvalid={
                                                            values.LDD_Rebate === "" &&
                                                            errors.LDD_Rebate &&
                                                            touched.LDD_Rebate
                                                        }
                                                        name="LDD_Rebate"
                                                        value={values.LDD_Rebate}
                                                    >
                                                    </Form.Control>
                                                </InputGroup>
                                                {errors.LDD_Rebate && touched.LDD_Rebate && (
                                                    <Form.Label style={Fontstyling.errorlabel}>
                                                        {errors.LDD_Rebate}
                                                    </Form.Label>
                                                )}
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <div className="text-end">
                                        <button
                                            style={Fontstyling.savebutton}
                                            type="submit"
                                            form="submitblockPricingExtrnal"
                                        >
                                            Save
                                        </button>

                                    </div>
                                </Form>
                            );
                        }}
                    </Formik>
                </Modal.Body>
            </Modal>

            <div style={{ ...Fontstyling.heading, textDecoration: 'underline' }}>Search Criteria: </div>
            <Formik
                enableReinitialize
                innerRef={formikRef}
                // validationSchema={schema}
                onSubmit={(values, { setSubmitting }) => {
                    handleActions(values);
                }}

                initialValues={{
                    PBM: "",
                }}
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    setFieldValue,
                    values,
                    touched,
                    isValid,
                    errors,
                    resetForm
                }) => {
                    const handleFormSubmit = async (e) => {
                        await handleSubmit(e);
                        if (Object.keys(errors).length > 0) {
                            const firstErrorField = Object.keys(errors)[0];
                            const errorFieldElement = document.getElementsByName(firstErrorField)[0];
                            if (errorFieldElement) {
                                errorFieldElement.focus();
                            }
                        }
                    };
                    return (
                        <Form onSubmit={(e) => {
                            handleFormSubmit(e);
                        }} id="blockPricingExtrnal" >
                            <Row className="my-3 gap-5  justify-content-between align-items-end">
                                <Col className="col-3 ">
                                    <Form.Group className="gap-3 ">
                                        <Form.Label
                                            className="text-nowrap "
                                            style={Fontstyling.label}
                                        >
                                            PBM
                                            {/* <Required /> */}
                                        </Form.Label>
                                        <Form.Select
                                            className="py-1 rounded-0"
                                            style={Fontstyling.label}
                                            name="PBM"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            isInvalid={
                                                errors.PBM &&
                                                touched.PBM
                                            }
                                            value={values.PBM}
                                        >
                                            <option value={""}>Select PBM</option>
                                            {dropDownList.PBMList?.filter((pbm) => {
                                                return (pbm.Id?.length === 0 || pbm?.Id)
                                            })?.map((npbm, npbmInd) => (
                                                <option value={JSON.stringify(npbm)}>
                                                    {npbm?.Label}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {errors.PBM && touched.PBM && (
                                            <Form.Label style={Fontstyling.errorlabel}>
                                                {errors.PBM}
                                            </Form.Label>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col className="col-3 d-flex gap-3" style={{ justifyContent: 'end' }}>
                                    <Button
                                        style={Fontstyling.cancelbutton}
                                        onClick={ClearCriteria}
                                    >
                                        Clear Criteria
                                    </Button>
                                    <Button
                                        form="blockPricingExtrnal"
                                        type="submit"
                                        style={Fontstyling.savebutton}
                                    >
                                        Search
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    );
                }}
            </Formik>
            <div className='d-flex mb-2 mt-5 justify-content-between'>
                <div  style={{ ...Fontstyling.heading, textDecoration: 'underline' }}>Search Results:  </div>
                {!isLoading && <div style={{ ...Fontstyling.heading}}>Total Records : {data?.length}</div>}
            </div>
            <div className='blockTable'>
                {showTable && (<CustomReactMaterialTable
                    data={data}
                    columns={column}
                    selectedRow={selectedRow}
                    setSelectedRow={setSelectedRow}
                    setWitchAction={setWitchAction}
                    setSelectedRowData={setSelectedRowData}
                    setShowModal={setShowModal}
                    isLoading={isLoading}
                    isExport={false}
                    isEdit={true}
                    isDelete={true}
                    isActionColumn={false}
                    isPagination={false}
                />)}
            </div>
            {showEditIcon ?
                <>
                    <div className="text-end">
                        <CustomButton
                            className="mt-4"
                            onClick={() => {
                                setWitchAction("add");
                                setShowModal(true);
                            }}
                        >
                            Add New Rates
                        </CustomButton>
                    </div>
                    <div className="mb-3" style={Fontstyling.heading}>Mass Update:   </div>
                    {/* Error model 2 */}
                    <Modal
                        show={message.isModal && message.success === false}
                        onHide={() => setMessage((prev) => ({ ...prev, isModal: false }))}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>Error</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            There are blank or invalid values in your import file. Please click
                            Download Error Log, correct the import file accordingly, and try
                            again.
                        </Modal.Body>
                        <Modal.Footer>
                            <div>
                                <Button
                                    className="bg-transparent border-0 text-primary"
                                    onClick={() => {
                                        DownloadCensusErrorFile(message.file).then((data) => {
                                            const blob = new Blob([data.data], {
                                                type: "text/plain",
                                            });
                                            const url = URL.createObjectURL(blob);
                                            const a = document.createElement("a");
                                            a.href = url;
                                            a.download = message.file;
                                            document.body.appendChild(a);
                                            a.click();
                                            document.body.removeChild(a);
                                            URL.revokeObjectURL(url);
                                            setMessage((prev) => ({ ...prev, isModal: false, file: "" }));
                                        });
                                    }}
                                >
                                    Download Error Log
                                </Button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                    <Row className="my-3">
                        <Col className="col-8" style={Fontstyling.label}>
                            <ul className="" style={{ listStyle: 'none' }}>
                                You can update ALL pricing rates at one time by importing.
                                <li>Step 1: Click the “Download Current Pricing Detail” button to download the current pricing</li>
                                <li>Step 2: Update the rates on the downloaded file.</li>
                                      <p className="ms-5 mb-0">NOTE: </p>
                                      <p className="mt-0 mb-0" style={{marginLeft:'80px'}}> a. DO NOT change column name and column headers orders. </p>
                                      <p className="mt-0 mb-0" style={{marginLeft:'80px'}}> b. All rates must be in Number format. For example, enter 0.25, instead of 25%." </p>
                                <li>Step 3: Save it as a CSV file</li>
                                <li>Step 4: Click the “Import new Pricing Detail” button, to import the file.</li>
                            </ul>
                        </Col>
                        <Col className="text-end">
                            <div className="my-4 " >
                                <CustomButton
                                    className='px-4 py-2 rounded'
                                    style={{ ...Fontstyling.addnewbutton, width: 200 }}
                                    onClick={() => downloadExisRxBlockPricing(allData, "Rx_Block_Pricing.csv")}
                                >
                                    Download current Pricing Detail
                                </CustomButton>
                            </div>
                            <div className="mt-4">
                                <CustomButton
                                    className='px-4 py-2 rounded'
                                    style={{ ...Fontstyling.addnewbutton, width: 200 }}
                                    onClick={() => {
                                        fileInputRef?.current?.click();
                                    }}
                                >
                                    Import New Pricing Detail
                                </CustomButton>
                               
                                <br />
                                {/* <p className="pe-1" style={Fontstyling.label}>{newPricingDetils?.name}</p> */}
                            </div>
                            <div >
                                <input
                                    type="file"
                                    accept=".csv"
                                    ref={fileInputRef}
                                    className='py-1 rounded-0 d-none'
                                    style={Fontstyling.label}
                                    placeholder="Select File"
                                    name="file"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        handleImportFile(file);
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                </>
                : 
                <div className="my-2" style={{textAlign:'end'}}>
                    <CustomButton
                        className='px-4 py-2 rounded '
                        style={{ ...Fontstyling.addnewbutton, }}
                        onClick={() => downloadExisRxBlockPricing(allData, "Rx_Block_Pricing.csv")}
                    >
                        Download current Pricing Detail
                    </CustomButton>
                </div>
            }
        </div>
    );
};

export default RxBlockPricingEx;




